module.exports = __webpack_public_path__ + "img/map_Z3.2.C.04.a1a5ee3d.svg";